// AUTO-GENERATED. Do not edit. Regenerated by scripts/generate-build-info.js.
// Runs on prestart/prebuild — see package.json scripts.
export const BUILD_VERSION = "2.1.24";
export const GIT_COMMIT_SHORT = "02b4b2e0";
export const BUILD_TIMESTAMP = "2026-06-17T13:21:06.085Z";
